import React, { useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import { useTranslation } from 'react-i18next';
import { CancelButton } from '../../ui';
import Loading from '../../Loading/Loading';
import { getEmail } from '../../../store/email/sagas';

interface Props {
  id?: number;
  html?: string;
  show?: boolean;
  onClose: () => void;
}

const EmailDialog: React.FC<Props> = ({ id, html: htmlProp, show = true, onClose }) => {
  const { t, i18n } = useTranslation();
  const [html, setHtml] = React.useState<string | undefined>(htmlProp);

  useEffect(() => {
    if (id !== undefined) {
      getEmail(id).then((response) => {
        if (response.type === 'ok') {
          setHtml(response.value.data.html);
        }
      });
    }
  }, [id]);

  return (
    <Dialog
      open={show}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      maxWidth="lg"
    >
      <DialogActions>
        <CancelButton onClick={onClose}>{t('Close')}</CancelButton>
      </DialogActions>
      {!html ? <Loading /> : <iframe srcDoc={html} height="1200px" className="emailIframe"></iframe>}
    </Dialog>
  );
};

export default EmailDialog;
